import {createReducer} from "./utils/createReducer";
import { ModalAction } from "../action/modalActions";

interface IModalState {
    type: string | null;
    title: string | null;
    contentText: string | null;
    isOpen: boolean;
    isLoading: boolean; 
    onClose: () => void | null;
    onSubmit: () => void | null;
    content: any | null;
    maxWidth: string | null;
    fullScreen: boolean;
    isValid: boolean;
    callback: () => void | null;
    cancelLabel: string | null;
    confirmLabel: string | null;
}

const defaultState: IModalState = {
    type: null,
    title: null,
    contentText: null,
    isOpen: false,
    isLoading: false,
    onClose: null,
    onSubmit: null,
    content: null,
    maxWidth: null,
    fullScreen: false,
    isValid: true,
    callback: null,
    cancelLabel: null,
    confirmLabel: null
};


const initModal = (state, action) => ({
    ...state,
    ...action.modal
})
const openModal = (state, action) => ({
    ...state,
    isOpen: true,
    ...action.modal && action.modal
})
const closeModal = (state, action) => ({
    ...state,
    isOpen: false,
})
const resetModal = (state, action) => ({
    ...defaultState
})

export const modalReducer = createReducer<IModalState>(defaultState, {
  [ModalAction.INIT_MODAL]: initModal,
  [ModalAction.OPEN_MODAL]: openModal,
  [ModalAction.CLOSE_MODAL]: closeModal,
  [ModalAction.RESET_MODAL]: resetModal,
});



// WEBPACK FOOTER //
// ./src/core/redux/reducer/modalReducer.ts